import styled from "styled-components"
import breakpoint from "styled-components-breakpoint"

export const A = styled.a`
  color: ${({ theme }) => theme.colors.primary};
  display: block;
  text-decoration: none;
  margin-top: 1rem;
`

export const VideoWrapper = styled.div`
  position: relative;
  height: 100%;
`

export const Icon = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 3rem;
  color: #fff;
  cursor: pointer;
`

export const Wrapper = styled.div`
  border-radius: 1rem;
  background: ${({ theme }) => theme.colors.content.background};
  width: 100%;
`

export const Div = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  border-radius: 1rem;
  margin-top: 1.5rem;

  ${breakpoint("tablet")`
    margin-top: 0;
    flex-wrap: nowrap;
    width: 100%;
  `};
`

export const StyledButton = styled.button`
  background-color: transparent;
  border-radius: 8px;
  border: 1px solid #505050;
  cursor: pointer;
  color: #505050;
  font-size: 16px;
  padding: 10px 20px;

  &:hover {
    background-color: #fff;
  }

  ${({ danger }) =>
    danger &&
    `
    margin-top: 1rem;
    background-color: ${({ theme }) => theme.colors.danger} !important;
    color: #fff;
  `}
`
export const TwoThirds = styled.div`
  padding: 0;
  width: 100%;
  ${({ increaseHeight }) => increaseHeight && "height: 20rem"};
  ${breakpoint("tablet")`
    padding: 2rem 0 2rem 2rem;
  `};
`

export const OneThird = styled.div`
  width: 100%;
  text-align: center;
  padding: 2rem 0 2rem 0rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${breakpoint("tablet")`
    ${({ padding }) => (padding ? "padding: 0rem 3rem 0rem 0rem;" : "padding: 0;")}
  `}
`

export const P = styled.p`
  margin-top: 1rem;
  margin-bottom: 0;
  font-size: 2rem;
  color: ${({ theme }) => theme.colors.primary};
  font-size: 10rem;
  text-align: center;

  &:hover {
    cursor: pointer;
  }
  ${breakpoint("tablet")`
    margin: 0;
  `}
`

export const ProgressContainer = styled.div`
  width: 300px;
  margin: auto auto 1rem auto;
`
export const ProgressBar = styled.div`
  height: 4px;
  background-color: rgba(5, 114, 206, 0.2);
  width: 100%;
  overflow: hidden;
`
export const ProgressBarValue = styled.div`
  width: ${({ progress }) => progress}%;
  height: 100%;
  background-color: rgb(5, 114, 206);
  transition: width 0.2s ease;
`

export const ProgressText = styled.p`
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.primary};
  text-align: center;
  height: 1rem;
`
